'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _noop2 = require('lodash/noop');

var _noop3 = _interopRequireDefault(_noop2);

var _tail2 = require('lodash/tail');

var _tail3 = _interopRequireDefault(_tail2);

var _head2 = require('lodash/head');

var _head3 = _interopRequireDefault(_head2);

var _get2 = require('lodash/get');

var _get3 = _interopRequireDefault(_get2);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class, _desc, _value, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _class3, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _mobx = require('mobx');

var _mobxReact = require('mobx-react');

var _classAutobindDecorator = require('class-autobind-decorator');

var _classAutobindDecorator2 = _interopRequireDefault(_classAutobindDecorator);

var _reactTooltip = require('react-tooltip');

var _reactTooltip2 = _interopRequireDefault(_reactTooltip);

var _reactTable = require('react-table');

var _reactTable2 = _interopRequireDefault(_reactTable);

var _selectTable = require('react-table/lib/hoc/selectTable');

var _selectTable2 = _interopRequireDefault(_selectTable);

var _Well = require('react-bootstrap/lib/Well');

var _Well2 = _interopRequireDefault(_Well);

var _ButtonToolbar = require('react-bootstrap/lib/ButtonToolbar');

var _ButtonToolbar2 = _interopRequireDefault(_ButtonToolbar);

var _Button = require('react-bootstrap/lib/Button');

var _Button2 = _interopRequireDefault(_Button);

var _MedicalDetailsModal = require('../../MedicalDetailsModal');

var _MedicalDetailsModal2 = _interopRequireDefault(_MedicalDetailsModal);

var _TableRenderingUtils = require('../../../../utils/TableRenderingUtils');

var _constants = require('../../../../constants');

var _GenericFundingDetailsModal = require('../../GenericFundingDetailsModal');

var _GenericFundingDetailsModal2 = _interopRequireDefault(_GenericFundingDetailsModal);

var _common = require('../../../common');

var _utils = require('../../../../utils');

var _util = require('../../../../utils/util');

var _Columns = require('./Columns');

var _MakeAvailableForCoopModal = require('./MakeAvailableForCoopModal');

var _MakeAvailableForCoopModal2 = _interopRequireDefault(_MakeAvailableForCoopModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  Object.defineProperty(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var LIEN_MODELS = _constants.AppConstants.LIEN_MODELS,
    TOOLTIP_ID_TABLE = _constants.AppConstants.TOOLTIP_ID_TABLE,
    CheckboxTable = (0, _selectTable2.default)(_reactTable2.default);
var FundingsTable = (_dec = (0, _mobxReact.inject)('FunderStore', 'UiStore'), _dec(_class = (0, _classAutobindDecorator2.default)(_class = (0, _mobxReact.observer)(_class = (_class2 = (_temp = _class3 = function (_Component) {
  _inherits(FundingsTable, _Component);

  function FundingsTable(props) {
    _classCallCheck(this, FundingsTable);

    var _this = _possibleConstructorReturn(this, (FundingsTable.__proto__ || Object.getPrototypeOf(FundingsTable)).call(this, props));

    _initDefineProp(_this, 'showMedicalDetailsModal', _descriptor, _this);

    _initDefineProp(_this, 'showGenericDetailsModal', _descriptor2, _this);

    _initDefineProp(_this, 'showMakeAvailableToCoopModal', _descriptor3, _this);

    _initDefineProp(_this, 'selectedRows', _descriptor4, _this);

    _initDefineProp(_this, 'selectAllRows', _descriptor5, _this);

    var columns = props.columns;


    _this.columns = columns.slice();
    _this.columns = [(0, _head3.default)(_this.columns), _Columns.VANITY_ID_COLUMN].concat(_toConsumableArray((0, _tail3.default)(_this.columns)));
    return _this;
  }

  _createClass(FundingsTable, [{
    key: 'onViewFundingClick',
    value: function onViewFundingClick(rowInfo) {
      var lien = rowInfo.original,
          UiStore = this.props.UiStore;

      this.lienId = lien.id;

      if (lien.type === LIEN_MODELS.MEDICAL.model) {
        this.showMedicalDetailsModal = true;
      } else if (lien.type === LIEN_MODELS.GENERIC.model) {
        this.showGenericDetailsModal = true;
      } else {
        UiStore.modals.FundingDetails.lien = rowInfo.original;
        UiStore.modals.FundingDetails.open();
      }
    }
  }, {
    key: 'closeMedicalDetailsModal',
    value: function closeMedicalDetailsModal() {
      this.showMedicalDetailsModal = false;
    }
  }, {
    key: 'closeGenericDetailsModal',
    value: function closeGenericDetailsModal() {
      this.showGenericDetailsModal = false;
    }
  }, {
    key: 'getTdProps',
    value: function getTdProps(state, rowInfo, column) {
      var isViewFundingColumn = column.className === 'view-funding-column',
          onClick = isViewFundingColumn && this.onViewFundingClick.bind(this, rowInfo);
      return { onClick: onClick };
    }
  }, {
    key: 'onSelectRows',
    value: function onSelectRows(selectedRows) {
      this.selectedRows = selectedRows;
      this.props.onCheck(this.selectedRows);
    }
  }, {
    key: 'isRowSelected',
    value: function isRowSelected(key) {
      return this.selectedRows.includes(key);
    }
  }, {
    key: 'toggleSelectAllRows',
    value: function toggleSelectAllRows() {
      var newSelectedRows = [];

      if (!this.selectAllRows) {
        newSelectedRows = this.props.liens.slice().map(function (lien) {
          return lien.id;
        });
      }

      this.selectAllRows = !this.selectAllRows;
      this.onSelectRows(newSelectedRows);
    }
  }, {
    key: 'toggleRowSelection',
    value: function toggleRowSelection(key, _shift, _row) {
      var selectedRows = (0, _util.toggleArrayIncludes)((0, _mobx.toJS)(this.selectedRows), key);
      this.onSelectRows(selectedRows);
    }
  }, {
    key: 'renderBulkActionButtons',
    value: function renderBulkActionButtons() {
      return _react2.default.createElement(
        _ButtonToolbar2.default,
        { className: 'toolbar-bulk' },
        _react2.default.createElement(
          _react.Fragment,
          null,
          !this.selectedRows.length ? _react2.default.createElement(
            'div',
            { className: 'bar' },
            _react2.default.createElement(
              'div',
              { className: 'info' },
              '(Select liens for bulk update)'
            )
          ) : _react2.default.createElement(
            'div',
            { className: 'bar' },
            _react2.default.createElement(
              'div',
              { className: 'info' },
              '(' + this.selectedRows.length + ')'
            ),
            _react2.default.createElement(
              _Button2.default,
              { bsStyle: 'link', onClick: this.showMakeAvailableToCoopModal.setTrue },
              _react2.default.createElement(_common.Icon, { type: 'dollar' }),
              ' Make available to CoOp Capital'
            )
          )
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          _case = _props._case,
          FunderStore = _props.FunderStore,
          liens = _props.liens,
          title = _props.title,
          newButton = _props.newButton,
          data = liens.slice(),
          defaultSorted = [{ desc: true, id: 'vanity_id' }],
          showBulkAction = FunderStore.isFinanceCustomer && title.includes('Open'),
          TableComponent = showBulkAction ? CheckboxTable : _reactTable2.default,
          checkboxProps = {
        isSelected: this.isRowSelected,
        selectAll: this.selectAllRows,
        selectedRows: this.selectedRows,
        selectType: 'checkbox',
        selectWidth: 40,
        toggleAll: this.toggleSelectAllRows,
        toggleSelection: this.toggleRowSelection
      },
          SelectAllInputComponent = _TableRenderingUtils.SelectInputComponent;


      SelectAllInputComponent.defaultProps = {
        listTitle: title
      };

      // read each value of each lien in order to get mobx to properly react when a lien is revised
      this.columns.forEach(function (column) {
        return data.forEach(function (lien) {
          return (0, _get3.default)(lien, column.columns[0].accessor);
        });
      });

      return _react2.default.createElement(
        _Well2.default,
        { className: 'case-items-list well-table' },
        _react2.default.createElement(
          'h3',
          { className: 'flex-between' },
          title,
          newButton
        ),
        showBulkAction && this.renderBulkActionButtons(),
        _react2.default.createElement(TableComponent, _extends({
          columns: this.columns,
          onSelectRows: this.onSelectRows,
          selectedRows: (0, _mobx.toJS)(this.selectedRows.map(function (selectedRow) {
            return selectedRow.id;
          })),
          data: data,
          defaultSorted: defaultSorted,
          getTdProps: this.getTdProps,
          resizable: false,
          sortable: true,
          pageSize: data.length,
          SelectAllInputComponent: SelectAllInputComponent,
          SelectInputComponent: _TableRenderingUtils.SelectInputComponent,
          showPagination: false,
          keyField: 'id',
          minRows: 0
        }, checkboxProps)),
        this.showMedicalDetailsModal && _react2.default.createElement(_MedicalDetailsModal2.default, {
          caseId: _case.id,
          onClose: this.closeMedicalDetailsModal,
          lienId: this.lienId
        }),
        this.showGenericDetailsModal && _react2.default.createElement(_GenericFundingDetailsModal2.default, {
          _case: _case,
          onClose: this.closeGenericDetailsModal,
          lienId: this.lienId
        }),
        _react2.default.createElement(_MakeAvailableForCoopModal2.default, {
          isVisible: this.showMakeAvailableToCoopModal,
          selectedLiens: this.selectedRows
        }),
        _react2.default.createElement(_reactTooltip2.default, {
          html: true,
          id: TOOLTIP_ID_TABLE,
          type: 'info',
          place: 'bottom'
        })
      );
    }
  }, {
    key: '__reactstandin__regenerateByEval',
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return FundingsTable;
}(_react.Component), _class3.defaultProps = {
  onCheck: _noop3.default
}, _class3.propTypes = {
  _case: _propTypes2.default.object.isRequired,
  columns: _propTypes2.default.array.isRequired,
  FunderStore: _propTypes2.default.object.isRequired,
  liens: _mobxReact.propTypes.arrayOrObservableArray.isRequired,
  newButton: _propTypes2.default.node,
  onCheck: _propTypes2.default.func,
  title: _propTypes2.default.string.isRequired,
  UiStore: _propTypes2.default.object.isRequired
}, _temp), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'showMedicalDetailsModal', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, 'showGenericDetailsModal', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, 'showMakeAvailableToCoopModal', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return new _utils.SmartBool();
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, 'selectedRows', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, 'selectAllRows', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _applyDecoratedDescriptor(_class2.prototype, 'onSelectRows', [_mobx.action], Object.getOwnPropertyDescriptor(_class2.prototype, 'onSelectRows'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'toggleSelectAllRows', [_mobx.action], Object.getOwnPropertyDescriptor(_class2.prototype, 'toggleSelectAllRows'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'toggleRowSelection', [_mobx.action], Object.getOwnPropertyDescriptor(_class2.prototype, 'toggleRowSelection'), _class2.prototype)), _class2)) || _class) || _class) || _class);
var _default = FundingsTable;
exports.default = _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(LIEN_MODELS, 'LIEN_MODELS', '/app/src/components/page-case/main-fundings/FundingsTable/FundingsTable.js');
  reactHotLoader.register(TOOLTIP_ID_TABLE, 'TOOLTIP_ID_TABLE', '/app/src/components/page-case/main-fundings/FundingsTable/FundingsTable.js');
  reactHotLoader.register(CheckboxTable, 'CheckboxTable', '/app/src/components/page-case/main-fundings/FundingsTable/FundingsTable.js');
  reactHotLoader.register(FundingsTable, 'FundingsTable', '/app/src/components/page-case/main-fundings/FundingsTable/FundingsTable.js');
  reactHotLoader.register(_default, 'default', '/app/src/components/page-case/main-fundings/FundingsTable/FundingsTable.js');
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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